import React, { useState } from "react";
import { LaundryIssueView } from "../components/HeaderAttribute";
import GridPage from "../components/GridPage";

const LaundryIssuePopup = ({ data, data1 }) => {
   

  return (
    <div class="w-full p-5">
      <div class=" border-black  "></div>
      <GridPage
        title={`Issues > ${data.LaundryIssueNo} > ${data.FormatedDate}`}
        header={LaundryIssueView}
        records={data1}
        addView={true}
        tableHeight="h-60 overflow-y-auto"
      />
    </div>
  );
};

export default LaundryIssuePopup;
